import React from "react";
import { useSelector } from "react-redux";
import { useFormikContext } from "formik";
import { selectAllRegistration } from "../../../../redux/slices/registrationSlice";
import { setTeams } from "../../../../redux/slices/teamsSlice";
import {
    selectTeamModalOpen,
    setAppTeamModalOpen,
} from "../../../../redux/slices/appSettingsSlice";
import TeamModalContent from "./TeamModalContent";

const ConnectedTeamModalContent = () => {
    const { values, setFieldValue } = useFormikContext();
    const { Team } = values;
    const hasSelectedTeam = !!Team;
    const teamModalOpen = useSelector(selectTeamModalOpen);
    const { currentRegistration } = useSelector(selectAllRegistration);

    // This prevents the background app from scrolling when modal is open
    if (teamModalOpen) {
        document.getElementById("app").classList.add("no-scroll");
    } else {
        document.getElementById("app").classList.remove("no-scroll");
    }

    const teamModalContentProps = {
        currentRegistration,
        hasSelectedTeam,
        setFieldValue,
        teamModalOpen,
        // Actions
        setTeams,
        setAppTeamModalOpen,
    };
    return <TeamModalContent {...teamModalContentProps} />;
};

export default ConnectedTeamModalContent;
